import { render, staticRenderFns } from "./ms-inquiry-detail.vue?vue&type=template&id=f327d762&scoped=true"
import script from "./ms-inquiry-detail.vue?vue&type=script&lang=js"
export * from "./ms-inquiry-detail.vue?vue&type=script&lang=js"
import style0 from "./ms-inquiry-detail.vue?vue&type=style&index=0&id=f327d762&prod&lang=scss&scoped=true"
import style1 from "./ms-inquiry-detail.vue?vue&type=style&index=1&id=f327d762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f327d762",
  null
  
)

export default component.exports